import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormService } from "../../../core/services/v2/form.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "formdocs-form-fixeddesign-preview",
  templateUrl: "./form-fixeddesign-preview.component.html",
  styleUrls: ["./form-fixeddesign-preview.component.scss"],
})
export class FormFixeddesignPreviewComponent implements OnInit {
  htmlPreview: any;
  formName: string;
  nonPdfForm:string[]=["PatientHistory",
    "PaymentAuthorization",
    "PreferredPharmacyInformation",
    "PatientRegistration",
    "PermissiontoReleaseInformation"];
    isnonpdfForm:boolean=this.nonPdfForm.includes(this.data.formUrl);;

  constructor(
    public dialogRef: MatDialogRef<FormFixeddesignPreviewComponent>,
    private loaderService: WindowLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private formService: FormService
  ) {
    //this.isnonpdfForm=this.nonPdfForm.includes(this.data.formUrl);
    //console.log(this.data.formUrl);
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
 } 
  onExitClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.getFormName();
    
    //this.loaderService.show();
    if(this.isnonpdfForm){
      this.getStaticForm();
    }
    //this.getStaticForm();
  }

  getStaticForm() {
    this.loaderService.show();
    this.formService
      .getStaticFormPreview(112, this.data.formUrl)
      .subscribe((res) => {
        this.htmlPreview = res.result;
        this.loaderService.hide();
      });
  }

  getFormName() {
    this.formName = this.data.title;
  }
  showDoc() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.data.formUrl);
  }
}
